import React, {useCallback, useEffect, useRef, useState} from "react";
import {BiPlus} from "react-icons/bi";
import {FiSearch} from "react-icons/fi";
import {Link, useHistory, useParams, useRouteMatch} from "react-router-dom";
import BlockCustomDialog from "./BlockCustomDialog";
import {useMutation} from "react-query";
import {addPlayListContent, createTeacherPlayList, recentAddedPlayList, searchByTitle} from "../../api/playlist";
import moment from "moment";
import {useKeycloak} from "@react-keycloak/web";
import {MdOutlineCheckBox, MdOutlineCheckBoxOutlineBlank} from "react-icons/md";
import PropTypes from "prop-types";
import _ from "lodash";
import {setContentDetails} from "../../store/playListDetails";
import {useDispatch} from "react-redux";
import {IoMdArrowBack} from "react-icons/io";

const CheckBoxControl = ({checked, onChange}) => {
    return !checked ? (
        <MdOutlineCheckBoxOutlineBlank
            onClick={(event) => onChange(event, !checked)}
            size={20}
            color="white"
            className="mr-2 z-20"
        />
    ) : (
        <MdOutlineCheckBox
            size={20}
            onClick={(event) => onChange(event, !checked)}
            color="white"
            className="mr-2 z-20"
        />
    );
};

export default function BlockAddPlayListContent() {

    const history = useHistory();
    const {keycloak} = useKeycloak();
    const dispatch = useDispatch();
    const [searching, setSearching] = useState(false);
    const [isOpen, setOpen] = useState(false);
    const [playListTitle, _playListTitle] = useState('');
    const [playlistData, _playlistData] = useState([]);
    const playListRef = useRef(null);
    const {url} = useRouteMatch();
    const param = useParams();
    const ClassId = param.classId;
    const playListId = param.id;
    const splitData = url.split('/')
    const newUrl = splitData.slice(0, 4).join('/');
    const [playlists, setPlaylists] = useState([]);

    const fetchPlaylistContent = () => {
        recentAddedPlayList(playListId).then(res => {
            const data = res.data.body.content;
            const newData = data?.map((item) => {
                return {
                    ...item,
                    isSelected: true,
                    alreadyAdded: true,
                }
            })
            if (data?.length > 0) {
                setPlaylists(newData);
                playListRef.current = newData;
            } else {
                setPlaylists([]);
            }
        }).catch(error => console.log("error", error));
    }

    useEffect(() => {
        fetchPlaylistContent();
    }, []);

    //toggle selection for the checked and unchecked field
    const toggleSelection = (event, checked, index) => {
        event.stopPropagation();
        const newPlayLists = playlists.map((playlist, i) => {
            if (i === index) return {...playlist, isSelected: checked};
            return playlist;
        });
        setPlaylists(newPlayLists);
    };


    //create the new play list
    const {
        isLoading: isCreating,
        error: createError,
        isError: isCreateError,
        mutate,
        data
    } = useMutation(createTeacherPlayList, {
        onSuccess: (data, variables) => {
            if (data?.status === 201) {
                const playlistData = data.data.body;
                const id = playlistData.id;
                const title = playlistData.title;
                history.push({
                    pathname: `${newUrl}/playlist`,
                    state: {
                        id: id,
                        title: title
                    }
                });
                setOpen(false);
            } else {
                history.push(`${newUrl}/`);
            }
        },
        onError: (err) => {
            console.log(err);
        },
    });

    let insertPayList = () => {
        const start_time = moment().unix();
        const payload = {
            "id": ClassId,
            "title": playListTitle,
            "description": "string",
            "teacher_id": keycloak?.idTokenParsed?.sid,
            "createdOn": start_time,
            "modifiedOn": 0,
            "content": []
        }

        mutate(payload);
    }

    //add content to the current playlist
    const {
        mutate: addContent,
    } = useMutation(addPlayListContent, {
        onSuccess: (data, variables) => {
            if (data?.status === 201) {
                alert("playlist content added SuccessFully");
                history.push(`${newUrl}/remove-content-data/${playListId}`);
            } else {
                history.push(`${newUrl}/`);
            }
        },
        onError: (err) => {
            console.log(err);
            alert("Something Went wrong...");
        },
    });


    // add the content to playlist
    const addContentToPlaylist = () => {
        const filterContent = playlists.filter((item) => item.isSelected === true && !item?.alreadyAdded);
        const start_time = moment().unix();
        const finalData = filterContent?.map((item) => {
            return {
                "id": playListId,
                "sourceId": item.id,
                "createdOn": start_time,
                "modifiedOn": 0
            }
        });

        if (finalData?.length > 0) {
            addContent({playListId: playListId, addingPayload: finalData});
        } else {
            alert("please select at least one content OR playlist is already Added to add...");
        }
    }

    const redirectToTopic = (item) => {
        dispatch(setContentDetails(item))
        history.push(`${newUrl}/topic/${item?.id}`);
    }

    /** debounce function used to submit the search value after some delay*/
    const debouncedChangeHandler = _.debounce((event) => {
        const title = event.target.value;
        const existingPlayList = playListRef.current
        if (title.trim() !== '') {
            searchByTitle(title).then((res) => {
                const playList = res.data.body;
                const newPlaylistData = playList.map((item) => {
                    return {
                        ...item,
                        isSelected: false
                    }
                });
                if (existingPlayList?.length > 0) {
                    const newData = [...existingPlayList, ...newPlaylistData];
                    setPlaylists(newData);
                } else {
                    setPlaylists(newPlaylistData);
                }

            }).catch(error => console.log("Error", error));
        } else {
            setPlaylists(existingPlayList)
        }
    }, 300)

    //url used to go to the back
    const goBack = useCallback(() => history.goBack(), []);
    return (
        <>
            <div className="flex item-center border-b border-b-black gap-x-2">
                {searching ? (
                    <input
                        type="text"
                        className="bg-transparent w-full px-4 outline-0"
                        placeholder="Search"
                        onChange={debouncedChangeHandler}
                    />
                ) : (
                    <h4 className="text-xl flex-auto cursor-pointer" onClick={() => setSearching(true)}>Your
                        Content</h4>
                )}
                <FiSearch
                    size={20}
                    className="cursor-pointer"
                    onClick={() => setSearching(true)}
                />
                <BiPlus
                    size={20}
                    className="cursor-pointer"
                    onClick={() => setOpen(true)}
                />
            </div>

            <div className="flex flex-col flex-auto justify-between">
                <div className="flex-auto">
                    <h4 className="text-xl my-3 flex justify-start items-center">
                        <IoMdArrowBack
                            onClick={goBack}
                            size={30}
                            className="mr-3 cursor-pointer"
                        />
                        Recently played
                    </h4>
                    {playlists?.length > 0 ?
                        <div
                            className="relative grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 h-full overflow-y-auto cursor-pointer">
                            {playlists.map((item, index) => (
                                <div className="w-full  overflow-hidden" key={index}

                                >
                                    <div
                                        onClick={() => redirectToTopic(item)}
                                        className="rounded w-full aspect-video bg-cover flex flex-col justify-between relative z-10"
                                        style={{
                                            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0)), url(${
                                                item?.thumbnail
                                            })`,
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                        }}

                                    >
                                        <div className="flex justify-end pr-1 pt-1 z-20 absolute top-0 right-0">
                                            {item?.alreadyAdded ?
                                                <MdOutlineCheckBox
                                                    size={20}
                                                    color="white"
                                                    className="mr-2 z-20"
                                                /> :
                                                <CheckBoxControl
                                                    checked={item.isSelected}
                                                    onChange={(event, checked) => toggleSelection(event, checked, index)}
                                                />
                                            }
                                        </div>
                                        <div className="flex items-center gap-2 ml-2 mb-1 absolute bottom-0">
                                            <img
                                                src="https://cdn-icons-png.flaticon.com/512/1384/1384060.png "
                                                className="h-5 w-5"
                                                alt=""
                                            />
                                            <span className="text-white text-xs">{item?.source}</span>
                                        </div>
                                    </div>

                                    <p className="truncate text-sm mt-2.5">
                                        {item?.title}
                                    </p>
                                </div>
                            ))}
                        </div> :
                        <div className="flex justify-center">
                            <h3>PlayList Content not Available</h3>
                        </div>}
                </div>
                {playlists?.length !== 0 &&
                    <div className="flex justify-center">
                        <button
                            // onClick={() => history.push(`${newUrl}/add-content-data`)}
                            onClick={() => addContentToPlaylist()}
                            className="flex justify-center w-20 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
                            Add
                        </button>
                    </div>}
                <Link to={`${newUrl}/playlists`} className="ml-auto text-sm underline">View playlist</Link>
            </div>

            <BlockCustomDialog
                targetId="contentWrapperBox"
                open={isOpen}
                onClose={() => setOpen(false)}
                overlayClasses="justify-center items-center backdrop-blur-md"
            >
                <div className="w-96 flex flex-col rounded-full p-4">
                    <h4 className="text-lg text-center font-medium">
                        Create New Playlist
                    </h4>
                    <div className="mb-6">
                        <input
                            type="text"
                            placeholder="Give your playlist a name"
                            className="text-center w-full bg-neutral-100 py-4 px-2 my-2"
                            onChange={(e) => _playListTitle(e.target.value)}
                        />
                    </div>
                    <button onClick={insertPayList}
                            className="w-40 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
                        Create
                    </button>
                </div>
            </BlockCustomDialog>
        </>
    );
}
CheckBoxControl.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func
}
